<template>
  <div class="page-wrapper">
    <Header />
    <main class="page-main">
      <HeroWhoWeAre />
      <TheProblemSection />
      <OurBeliefSection />
      <TeamSection />
      <FinalCTASection />
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from '../components/Header.vue';
import HeroWhoWeAre from '../components/WhoWeAre/HeroWhoWeAre.vue';
import Footer from '../components/Footer.vue';
import FinalCTASection from '../components/FinalCTASection.vue';
import TheProblemSection from '../components/WhoWeAre/TheProblemSection.vue';
import OurBeliefSection from '../components/WhoWeAre/OurBeliefSection.vue';
import TeamSection from '../components/WhoWeAre/TeamSection.vue';

export default {
  components: {
    Header,
    HeroWhoWeAre,
    TheProblemSection,
    OurBeliefSection,
    TeamSection,
    FinalCTASection,
    Footer
  }
};
</script>
